import { Joi } from '@ksyos/koi';
import type { ISchemaContainer } from '@common/validation/schemaContainer';

/**
 * Creates a new Joi schema by picking and extracting specified keys from an existing schema.
 * @param originalSchema The Joi schema to extract keys from.
 * @param keysToPick An array of keys to include in the new schema.
 * @returns A new Joi object schema containing only the specified keys.
 */
export function pickKeysAndCreateSchema<T extends Joi.Schema>(
    originalSchema: T,
    keysToPick: string[]
): Joi.ObjectSchema {
    const pickedKeys: { [key: string]: Joi.Schema } = {};
    keysToPick.forEach((key) => {
        // Check if the key exists in the original schema to avoid errors
        if ((originalSchema as any).$_terms.keys.some((item: any) => item.key === key)) {
            pickedKeys[key] = originalSchema.extract(key); // Extract the schema definition
        }
    });

    return Joi.object().keys(pickedKeys);
}

export function pickKeysAndCreateSchemaTyped<T>(
    originalSchema: ISchemaContainer<T>,
    keysToPick: (keyof T)[]
): ISchemaContainer<Pick<T, keyof T>> {
    const schema: Joi.ObjectSchema<Pick<T, keyof T>> = pickKeysAndCreateSchema(
        originalSchema.schema,
        keysToPick as string[]
    );

    return {
        schema,
    };
}
